import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var postUserInfo = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var postId, _ref$whatsapp_optin, whatsapp_optin, applicant_name, mobile_number, city_id, gender, id_number, first_payment, last_payment, installment_period, monthly_installment, warranty_id, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          postId = _ref.postId, _ref$whatsapp_optin = _ref.whatsapp_optin, whatsapp_optin = _ref$whatsapp_optin === void 0 ? 0 : _ref$whatsapp_optin, applicant_name = _ref.applicant_name, mobile_number = _ref.mobile_number, city_id = _ref.city_id, gender = _ref.gender, id_number = _ref.id_number, first_payment = _ref.first_payment, last_payment = _ref.last_payment, installment_period = _ref.installment_period, monthly_installment = _ref.monthly_installment, warranty_id = _ref.warranty_id;
          params = {
            id: postId,
            whatsapp_optin: whatsapp_optin,
            applicant_name: applicant_name,
            mobile_number: mobile_number,
            city_id: city_id,
            gender: gender,
            id_number: id_number,
            post_id: postId,
            first_payment: first_payment,
            last_payment: last_payment,
            installment_period: installment_period,
            monthly_installment: monthly_installment
          };
          if (warranty_id) {
            params.warranty_id = warranty_id;
          }
          _context.n = 1;
          return fetcher(null, true).post('finance/create', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function postUserInfo(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default postUserInfo;